import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Badge Component - Status and category badges with Ikigai quadrant variants
 * @ownyou/ui-components
 */
import { cn } from '@ownyou/ui-design-system';
const VARIANT_CLASSES = {
    default: 'bg-neutral-100 text-neutral-700',
    success: 'bg-green-100 text-green-700',
    warning: 'bg-amber-100 text-amber-700',
    error: 'bg-red-100 text-red-700',
    passion: 'bg-rose-100 text-rose-700',
    mission: 'bg-violet-100 text-violet-700',
    profession: 'bg-cyan-100 text-cyan-700',
    vocation: 'bg-emerald-100 text-emerald-700',
};
const DOT_COLOR = {
    default: 'bg-neutral-500',
    success: 'bg-green-500',
    warning: 'bg-amber-500',
    error: 'bg-red-500',
    passion: 'bg-rose-500',
    mission: 'bg-violet-500',
    profession: 'bg-cyan-500',
    vocation: 'bg-emerald-500',
};
const SIZE_CLASSES = {
    sm: 'px-2 py-0.5 text-small',
    md: 'px-2.5 py-1 text-caption',
};
export function Badge({ variant = 'default', size = 'md', dot = false, children, className, ...rest }) {
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1 rounded-full font-medium', VARIANT_CLASSES[variant], SIZE_CLASSES[size], className), ...rest, children: [dot && (_jsx("span", { className: cn('w-1.5 h-1.5 rounded-full', DOT_COLOR[variant]), "data-testid": "badge-dot", "aria-hidden": "true" })), children] }));
}
export default Badge;
